import { render, staticRenderFns } from "./InputSumPage.vue?vue&type=template&id=2d2889bb"
import script from "./InputSumPage.vue?vue&type=script&lang=js"
export * from "./InputSumPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports